
(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('CompanyPageController', CompanyPageController)

    CompanyPageController.$inject = ['$state','$stateParams','$scope','$rootScope', '$filter', '$timeout', '$q', 'Sample', 'SampleSearch',
        'AlertService', 'pagingParams', 'SampleFilter',
        'SampleAttach','SampleAttachDownload', 'SampleExportService', 'ProductCategory','ProductTypeByCategory', 'CompanyPage', 'Principal', 'SampleCoaPdfService', 'DownloadUtil', 'SampleService', 'GraphQLService'];

    function CompanyPageController($state, $stateParams,$scope, $rootScope, $filter, $timeout, $q, Sample, SampleSearch, AlertService, pagingParams, SampleFilter,
                                 SampleAttach,SampleAttachDownload, SampleExportService, ProductCategory, ProductTypeByCategory, CompanyPage, Principal, SampleCoaPdfService, DownloadUtil, SampleService, GraphQLService) {

        var vm = this;
  $rootScope.showSearch = pagingParams.search;
        
        // Initialize totalFilters property
        vm.totalFilters = 0;

  vm.isAuthenticated = Principal.isAuthenticated;

        vm.search = search;
        vm.clear = clear;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.pagingParams = pagingParams;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.cannabioidWorksheets = null;

        $scope.isOtherAnalysis = isOtherAnalysis;
        $scope.hasOtherAnalyses = hasOtherAnalyses;
        $scope.hasCannabinoids = hasCannabinoids;
        $scope.getTotalThc = getTotalThc;
		vm.isinPortal = false
		if(window.top == window.self){
			vm.isinPortal = true
		}
		else{
			vm.isinPortal = false
		}

        $scope.assayIdentifierToName = function(identifier){
        	var assayIdMap = {
        			'POTENCY_LCMSMS': 'Cannabinoid Profile',
        			'POTENCY_GCFID': 'Cannabinoid Profile',
        			'POTENCY_LCDAD': 'Cannabinoid Profile',
        			'POTENCY_LCDAD_NON_PLANT': 'Cannabinoid Profile',
        			'RESIDUAL_SOLVENT_PHASE_II': 'Residual Solvents',
        			'RESIDUAL_SOLVENT_PHASE_I': 'Residual Solvents',
        			'HEAVY_METALS': 'Heavy Metals',
        			'HEAVY_METALS_FOOD': 'Heavy Metals',
        			'TERPENE_PROFILE': 'Terpene Profile',
        			'PESTICIDES_PLUS': 'Pesticide Screen',
        			'PESTICIDES_PHASE_II': 'Pesticide Screen',
        			'MICRO_QA_SCREEN': 'Microbiology',
        			'MICRO_PLUS': 'Microbiology',
        			'MICRO_INHALABLES': 'Microbiology',
        			'MICRO_NON_INHALABLES': 'Microbiology',
        			'MYCOTOXINS': 'Mycotoxins',
        			'WATER_ACTIVITY': 'Water Activity',
        			'FOREIGN_MATERIAL': 'Foreign Materials',
        			'MOISTURE': 'Moisture',
        			'SULFUR': 'Sulfur',
        			'HOMOGENEITY': 'Homogeneity',
        			'HOMOGENEITY_5': 'Homogeneity',
        			'PESTICIDES_MYCOTOXINS': 'Pesticides + Mycotoxins',
        			//'ALKALOID': 'Alkaloid'
        	}

        	var assay = assayIdMap[identifier];
        	if (!assay){
        		return "";
        	} else {
        		return assay;
        	}
        }
        $scope.canSeeOtherAnalyses = function(sample) {
        	var canSee = true;
        	for (var i = 0; i < sample.sampleTests.length; i++) {
        		var test = sample.sampleTests[i];
        		if (!test.assay) continue;
        		if (test.assay.id === 18 || test.assay.id === 19 || test.assay.id === 15) {
        			if (!test.canSeeResults) canSee = false;
        		}
        	}
        	return canSee;
        }
        $scope.canSeeTest = function(sample, testName) {
        	var assayIdMap = {
        			'POTENCY_LCMSMS': 'Cannabinoid Profile',
        			'POTENCY_GCFID': 'Cannabinoid Profile',
        			'POTENCY_LCDAD': 'Cannabinoid Profile',
        			'POTENCY_LCDAD_NON_PLANT': 'Cannabinoid Profile',
        			'RESIDUAL_SOLVENT_PHASE_II': 'Residual Solvents',
        			'RESIDUAL_SOLVENT_PHASE_I': 'Residual Solvents',
        			'HEAVY_METALS': 'Heavy Metals',
        			'HEAVY_METALS_FOOD': 'Heavy Metals',
        			'TERPENE_PROFILE': 'Terpene Profile',
        			'PESTICIDES_PLUS': 'Pesticide Screen',
        			'PESTICIDES_PHASE_II': 'Pesticide Screen',
        			'MICRO_QA_SCREEN': 'Microbiology',
        			'MICRO_PLUS': 'Microbiology',
        			'MICRO_INHALABLES': 'Microbiology',
        			'MICRO_NON_INHALABLES': 'Microbiology',
        			'MYCOTOXINS': 'Mycotoxins',
        			'WATER_ACTIVITY': 'Water Activity',
        			'FOREIGN_MATERIAL': 'Foreign Materials',
        			'MOISTURE': 'Moisture',
        			'SULFUR': 'Sulfur',
        			'HOMOGENEITY': 'Homogeneity',
        			'HOMOGENEITY_5': 'Homogeneity',
        			'PESTICIDES_MYCOTOXINS': 'Pesticides + Mycotoxins',
        			//'ALKALOID': 'Alkaloid'
        	}
        	for (var i = 0; i < sample.sampleTests.length; i++) {
        		var test = assayIdMap[sample.sampleTests[i].assay.portalIdentifier];
        		if (test === testName) {
        			return sample.sampleTests[i].canSeeResults;
        		}
        	}
		}

		vm.downloadSampleCOA =  function(sample_id, sample_hash) {
			var a = document.createElement("a");
			document.body.appendChild(a);
			a.style = "display: none";
			SampleCoaPdfService.downloadPdf(sample_hash).then(function(result) {
				var file = new Blob([result.data], {
					type: 'application/pdf'
				});

				a.href = window.URL.createObjectURL(file);
				a.download = sample_id + '_COA_Summary.pdf';
				a.click();
			});
		}

		vm.determinePfDisplay = function(pf) {
			switch(pf){
				case "PASS":
					return "<p class=\"test-pass\" style=\"color: #28d300\">\
								<span class=\"fa fa-check-circle test-result-icon\"></span>\
								<span class=\"test-result-text\">&nbsp;Pass</span>\
							</p>";
				case "FAIL" :
					return "<p class=\"test-fail\" style=\"color: red\">\
								<span class=\"fa fa-times-circle test-result-icon\"></span>\
								<span class=\"test-result-text\">&nbsp;Fail</span>\
							</p>";
				case "IN_PROGRESS":
					return "<p class=\"test-in-progress\" style=\"color: #ff8100\">\
								<span class=\"fa fa-clock-o test-result-icon\"></span>\
								<span class=\"test-result-text\">&nbsp;In Progress</span>\
							</p>";
				case "NO_STATUS":
					return "<p class=\"test-in-progress\" style=\"color: gray\">\
								<span class=\"fa fa-times-circle test-result-icon\"></span>\
								<span class=\"test-result-text\">&nbsp;Not Tested</span>\
							</p>";
				case "RETESTING":
					return "<p class=\"test-retesting\" style=\"color: #5eb1bf\">\
								<span class=\"fa fa-repeat test-result-icon\"></span>\
								<span class=\"test-result-text\">&nbsp;Retesting</span>\
							</p>";
				default:
					return "<p class=\"not-tested\" style=\"color: gray\">\
								<span class=\"fa fa-stop-circle test-result-icon\"></span>\
								<span class=\"test-result-text\">&nbsp;No Status</span>\
							</p>";
			}
		}

		$scope.determineTestPf = function(test) {
			var html = '';

			var testTitle = test.assay && test.assay.title ? test.assay.title : '-';
			if (test.state != 'COMPLETED' && test.estimatedCompleteDate) {
				var dueDate = new Date(test.estimatedCompleteDate);
				var formattedDate = ('0' + (dueDate.getUTCMonth() + 1)).slice(-2) + '/' + 
									('0' + dueDate.getUTCDate()).slice(-2) + '/' + 
									 dueDate.getUTCFullYear();
				testTitle += ' <span style="color: #8795a1; font-size: 11px;">(' + formattedDate + ')</span>';
			}

			html += '<tr>';
			html += '<td>' + testTitle + '</td>';

			if (test.canSeeResults) {
				if (test.state === 'RETESTING') {
					html += '<td class="test-retesting">Retesting</td>';
				} else if (test.caution) {
					html += '<td class="test-caution">Caution</td>';
				} else if (test.state === 'NOT STARTED') {
					if (test.estimatedCompleteDate) {
						html += '<td class="test-in-progress">In Progress</td>';
					} else {
						html += '<td class="test-not-started">Created</td>';
					}
				} else if (test.state === 'IN PROGRESS') {
					html += '<td class="test-in-progress">In Progress</td>';
				} else if (test.worksheetData) {
					var hidePf = test.worksheetData.do_not_show_pass_fail_in_portal && test.worksheetData.do_not_show_pass_fail_in_portal.value;

					if (hidePf) {
						if (test.state === 'COMPLETED') {
							html += '<td class="test-no-pf-status">Tested</td>';
						} else {
							html += '<td class="test-in-progress">In Progress</td>';
						}
					} else if (test.statusPf === 'PASS') {
						html += '<td class="test-pass">Pass</td>';
					} else if (test.statusPf === 'FAIL') {
						html += '<td class="test-fail">Fail</td>';
					} else if (test.state === 'COMPLETED') {
						html += '<td class="test-no-pf-status">Tested</td>';
					} else {
						html += '<td class="test-in-progress">In Progress</td>';
					}
				} else if (test.results) {
					html += '<td class="test-pass">Tested</td>';
				} else if (test.worksheetData && test.worksheetData.findings_1 && test.worksheetData.findings_1.value) {
					html += '<td class="test-pass">Tested</td>';
				} else {
					html += '<td class="test-fail">-</td>';
				}
			} else {
				if (test.state === 'RETESTING') {
					html += '<td class="test-retesting">Retesting</td>';
				} else if (['PASS', 'FAIL', 'COMPLETED'].indexOf(test.state) !== -1) {
					html += '<td class="test-retesting">Final Review</td>';
				} else {
					html += '<td class="test-in-progress">In Progress</td>';
				}
			}

			html += '</tr>';
			return html;
		}

		vm.determinePotencyDisplay = function(sample, potencyType, total, show_dash) {
			if (!sample || !sample.sampleTests) {
				if (potencyType === 'thc' && sample && sample.thcDisplay) {
					return sample.thcDisplay;
				}
				if (potencyType === 'cbd' && sample && sample.cbdDisplay) {
					return sample.cbdDisplay;
				}
				if (total && sample && sample.totalCannabinoidsDisplay) {
					return sample.totalCannabinoidsDisplay;
				}
				return show_dash ? '-' : '';
			}

			if (!total && potencyType === 'thc' && sample.thcDisplay) {
				return sample.thcDisplay;
			}
			if (!total && potencyType === 'cbd' && sample.cbdDisplay) {
				return sample.cbdDisplay;
			}
			if (total && sample.totalCannabinoidsDisplay) {
				return sample.totalCannabinoidsDisplay;
			}

			if (!vm.cannabioidWorksheets || !vm.cannabioidWorksheets.length) {
				return show_dash ? '-' : '';
			}

			var potency = '';

			if (total) {
				potencyType = 'thc';
			}

	        	for (var i = 0; i < sample.sampleTests.length && !potency; i++) {
				var test = sample.sampleTests[i];
				if (!isCannabinoidWorksheet(test) || !test.worksheetData) {
					continue;
				}

				potency = getWorksheetPotency(test.worksheetData, potencyType, total);
			}

			if (show_dash) {
				return potency ? potency : '-';
			}
			return potency;
		}

        vm.downloadSamplesCsv = function downloadSamplesCsv () {

            var fileName = "samples.csv";
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            SampleExportService.downloadCsv().then(function (result) {
                var file = new Blob([result.data], {type: 'application/json'});
                var fileURL = window.URL.createObjectURL(file);
                a.href = fileURL;
                a.download = fileName;
                a.click();
            });


		}
		
		vm.showFile = function(name) {
			var dont_show = ['_Labels', '_QR', 'medium', 'serv', '_slider_', ]
			for( var i = 0; i < dont_show.length; i++) {
				if(name.includes(dont_show[i])) {
					return false;
				}
			}
			return true;
		}

		/* Download Samples */
        function downloadSamplesSuccess(fileName, result) {
    		if (result.data.byteLength == 0) {
    			vm.downloadSamplesNull = true;
    			vm.downloadingSamples = false;
    			return;
    		}

            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";

            var file = new Blob([result.data], {type: 'application/json'});
            var fileURL = window.URL.createObjectURL(file);
            a.href = fileURL;
            a.download = fileName;
            a.click();
            vm.downloadingSamples = false;
        }
        function downloadSamplesError(err) {
        	vm.downloadingSamples = false;
        	vm.downloadSamplesError = true;
        }

        vm.updateSamplePublicity = function(sample) {
            vm.getAttachmentsLoader = false;
            sample.attachments = null;
            Sample.public({id: sample.id, public: ':public'});

        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.downloadSampleStartDate = false;
        vm.datePickerOpenStatus.downloadSampleEndDate = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.downloadSample = {
        		startDate: null,
        		endDate: null,
        		type: 'COA'
        }

        vm.downloadingSamples = false;
        vm.downloadSamplesError = false;
        vm.downloadSamplesNull = false;

        vm.downloadSamples = function() {
        	vm.downloadSamplesError = false;
        	vm.downloadSamplesNull = false;
        	var sampleExportParams = {
                	startDate: vm.downloadSample.startDate ? vm.downloadSample.startDate.getTime()/1000 : null,
                	endDate: vm.downloadSample.endDate ? vm.downloadSample.endDate.getTime()/1000 : null,
                	type: vm.downloadSample.type
        	}
        	vm.downloadingSamples = true;
        	if (vm.downloadSample.type == "COA") {
            	SampleExportService.downloadCoa(sampleExportParams).then(function (result) {
                    var fileName = "samples";
                    if (sampleExportParams.startDate && sampleExportParams.endDate) {
                    	fileName += " " + $filter('date')(vm.downloadSample.startDate, 'MM-dd-yyyy') + " to " + $filter('date')(vm.downloadSample.endDate, 'MM-dd-yyyy');
                    } else if (sampleExportParams.startDate) {
                    	fileName += " after " + $filter('date')(vm.downloadSample.startDate, 'MM-dd-yyyy');
                    } else if (sampleExportParams.endDate) {
                    	fileName += " before " + $filter('date')(vm.downloadSample.endDate, 'MM-dd-yyyy');
                    }
                    fileName += ".zip";

            		downloadSamplesSuccess(fileName, result);

                }, function(error) {
                	downloadSamplesError(error);
                });
        	} else {
            	SampleExportService.downloadCsv(sampleExportParams).then(function (result) {
            		var fileName = "samples.csv";
            		downloadSamplesSuccess(fileName, result);

                }, function(error) {
                	downloadSamplesError(error);
                });
        	}
        }

        vm.getAttachmentsLoader = false;
        vm.testResultsCache = {};
        var deferredCompanyPageBatchLoad = null;

        vm.setpagesize = setpagesize;

        setPageTitle();
        getcannabinoidWorksheetIds();
        $scope.range = new Array(20);

        function setpagesize(pagesize) {
            vm.itemsPerPage = pagesize;
            loadAll ();
        }

		/* Page loads */
        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = null;
            vm.sampleFilters = {};
            vm.populateTypes();
            vm.totalFilters = 0; // Reset filter count
                        
            // Transition to update the URL and reload data
            vm.transition();
        }

        vm.toggleWidget = function(name) {
        	if (vm.activeWidget === "sampleEditColumns") {
        		saveSampleColumns();
        	}

        	vm.activeWidget = name === vm.activeWidget ? null : name;
        }

        function getcannabinoidWorksheetIds() {
        	SampleService.getWorksheetParserMap({},
    			function(data) {
    				vm.cannabioidWorksheets = data && data.cannabinoid_profile ? data.cannabinoid_profile : [];
    			},
    			function(e) {
    				console.log(e);
    			}
    		);
        }

        vm.sampleFilters = {
        		id: pagingParams.id,
        		orderId: pagingParams.orderId,
        		sampleName: pagingParams.sampleName,
        		lotNumber: pagingParams.lotNumber,
        		metrcId: pagingParams.metrcId,
        		categoryIdList: pagingParams.categoryIdList,
        		category: pagingParams.category,
        		subCategory: pagingParams.subCategory,
        		orderType: pagingParams.orderType,
        		thcLower: pagingParams.thcLower,
        		thcUpper: pagingParams.thcUpper,
        		cbdLower: pagingParams.cbdLower,
        		cbdUpper: pagingParams.cbdUpper,
        		isPass: pagingParams.isPass == 'true' ? pagingParams.isPass != null : null,
        		isFail: pagingParams.isFail == 'true' ? pagingParams.isFail != null : null,
        		isUndetermined: pagingParams.isUndetermined == 'true' ? pagingParams.isUndetermined != null : null,
        		isWeedmapsSuccess: pagingParams.isWeedmapsSuccess == 'true' ? pagingParams.isWeedmapsSuccess != null : null,
        		isWeedmapsFail: pagingParams.isWeedmapsFail == 'true' ? pagingParams.isWeedmapsFail != null : null,
        		isWeedmapsNone: pagingParams.isWeedmapsNone == 'true' ? pagingParams.isWeedmapsNone != null: null,
        		visibility: pagingParams.visibility,
        		completeDateLower: pagingParams.completeDateLower ? convertLocalDateFromServer(pagingParams.completeDateLower) : null,
        		completeDateUpper: pagingParams.completeDateUpper ? convertLocalDateFromServer(pagingParams.completeDateUpper) : null,
        		estimatedDueDateLower: pagingParams.estimatedDueDateLower ? convertLocalDateFromServer(pagingParams.estimatedDueDateLower) : null,
        		estimatedDueDateUpper: pagingParams.estimatedDueDateUpper ? convertLocalDateFromServer(pagingParams.estimatedDueDateUpper) : null,
        		starred: pagingParams.starred ? pagingParams.starred : null
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
        	var params = createFilterQueryParams();

        	if ($scope.starred)
        		params['starred'] = true;
        	else
        		params['starred'] = null;
                        
            // Update URL without reloading the page
            $state.go($state.current.name, params, { notify: false });
            
            // Manually reload the data
            loadAll();
        }

        function createFilterQueryParams() {
        	var params = {};
            var dateFields = ["completeDateLower", "completeDateUpper", "estimatedDueDateLower", "estimatedDueDateUpper"];            
        	for (var key in vm.sampleFilters) {
        		if (dateFields.indexOf(key) !== -1) {
         			params[key] = convertLocalDateToServer(vm.sampleFilters[key]);
         		} else if (vm.sampleFilters[key] !== "" && vm.sampleFilters[key] !== null && vm.sampleFilters[key] !== undefined) {
        			params[key] = vm.sampleFilters[key];
        		}
        	}

        	if ($scope.starred)
        		params['starred'] = true;

        	params.hash = vm.customerHash;
        	params.page = vm.page;
        	params.sort = vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc');
            params.search = vm.currentSearch;
            params.size = vm.itemsPerPage;
            params.items = params.size;
            params.productCategoryId = vm.productCategoryId;

        	return params;
        }

		$scope.starred = pagingParams.starred ? pagingParams.starred : false;

        
        vm.filterSubmit = function() {
            // Reset to first page
        	vm.page = 1;
            
            // Update filter count
            var filterCount = 0;
            for (var key in vm.sampleFilters) {
                if (vm.sampleFilters[key] !== null &&
                    vm.sampleFilters[key] !== undefined &&
                    vm.sampleFilters[key] !== "") {
                    filterCount++;
                }
            }
            vm.totalFilters = filterCount;
            
        	vm.transition();
        }

		vm.toggleStarredView = function() {
			$scope.starred = !$scope.starred;

			vm.filterSubmit();
		}

        function setPageTitle(){
            $rootScope.pageTitle = "Company Page";
            $rootScope.searchVm = vm;
        }

        vm.itemsPerPage = "20";
        vm.customerHash = pagingParams.hash ? pagingParams.hash : 100;


        vm.populateTypes = function() {
        	if (vm.sampleFilters.category) {
        		vm.productTypes = ProductTypeByCategory.query(vm.sampleFilters.category);
        	} else {
        		vm.productTypes = [];
        	}

        }

		vm.productCategories = ProductCategory.query();

		
		function showFiles(attachments) {
			var available_attachments = []

			attachments.forEach( function(attachment) {
				if(vm.showFile(attachment.file_name)) {
					available_attachments.push(attachment);
				}
			});

			return available_attachments;
		}


        $scope.getAttachments = function (sample,id) {
	        vm.getAttachmentsLoader = true;
	        vm.idOfSelectedSample = id;


	        if(sample.attachments != null){
		        vm.getAttachmentsLoader = false;
		        return;
	        }

	        CompanyPage.getAttachments({id: sample.hash}, onSuccess, onError);
	        function onSuccess(data, headers) {
		        vm.getAttachmentsLoader = false;
		        sample.attachments = showFiles(data);

	        }
	        function onError(error) {
	        	AlertService.error(error.data.message);
	        }
        }

		$scope.downloadAttachment = function (id_hash, sample) {
		    SampleAttachDownload.get({id: id_hash}, onSuccess, onError);

		    function onSuccess(data, headers) {
	            var a = document.createElement("a");
	            document.body.appendChild(a);
	            a.style = "display: none";

	            var fileURL = window.URL.createObjectURL(data.data);
	            a.href = fileURL;
				a.download = DownloadUtil.getFilenameFromContentDisposition(headers('content-disposition'));
	            a.click();
		        sample.select = "";
		    }
		    function onError(error) {

		    }
		}

        vm.createSamplePublicLink = function(sample) {
            var hash = sample.hash;
            var fullUrl = window.location.origin +"/#/ps/"+ sample.hash;
            vm.currentPublicSample = sample;
            ensureCompanyPageSampleBatchData(sample).catch(function(error) {
                console.error('GraphQL Error preloading company page sample batch data:', error);
            });
            return fullUrl;
        }

        vm.emailsPending = [""];
        vm.emailMessage = "";


        vm.sendPublicEmail = function (form) {
            vm.emailsPending = $('#testtaginput').tagsinput('items')
            vm.emailSubject = $('#emailSubject').val();
            //Send The Email
            if (form.$valid && vm.emailsPending.length > 0){
                $('#sendPublicSampleButton').attr("disabled", true);
                ensureCompanyPageSampleBatchData(vm.currentPublicSample).then(function() {
                    CompanyPage.sendEmail({
                        emails: vm.emailsPending,
                        message: vm.emailMessage,
                        public_link: vm.emailSamplePublicLink,
                        pic_url: vm.currentPublicSample.picture,
                        id: vm.currentPublicSample.hash,
                        totalTHC: getTotalThc(vm.currentPublicSample),
                        subject: vm.emailSubject
                    }, onSuccess, onError);
                }).catch(function(error) {
                    console.error('GraphQL Error loading company page sample data for email:', error);
                    $('#sendPublicSampleButton').attr("disabled", false);
                    AlertService.error('Unable to load sample potency right now.');
                });
            }
            else {
                if (vm.emailsPending.length == 0)
                    $('#emailValidation').show();
                return
            }
        	function onSuccess(data, headers) {
        		$('#emailModal').modal('hide');
        		$('#emailModalSuccess').modal('show');
        		$('#sendPublicSampleButton').attr("disabled", false);

	        }

	        function onError(error) {
	        	AlertService.error(error.data.message);
	        	vm.emailsPending = [""];
	            vm.emailMessage = "";
	            $('#sendPublicSampleButton').attr("disabled", false);

	        }
        }

    $('#emailModalSuccess').on('hidden.bs.modal', function() {
        	$('#testtaginput').tagsinput('removeAll');
        	$('#testtaginput').tagsinput('input')[0].placeholder = 'email@example.com';
        })


		$('#testtaginput').tagsinput({
			tagClass: function(item) {
				return 'custom-label label-email'
			}
		});

		$('#testtaginput').on('beforeItemAdd', function(event) {
			var email_re = "^\S+@\S+$";
			if (!event.item.match(/\S+@\S+\.\S+/)) {
				$('#emailValidation').show();
				event.cancel = true;
			} else {
				$('#emailValidation').hide();
				$('#testtaginput').tagsinput('input')[0].placeholder = '';
			}
		});

		$('#testtaginput').on('beforeItemRemove', function(event) {
			if ($('#testtaginput').tagsinput('input')[0].value.length > 0)
				event.cancel = true;
			  // event.item: contains the item
			  // event.cancel: set to true to prevent the item getting removed
		});

		$('#testtaginput').tagsinput('input')[0].type = 'email'

		function updateFilterCount() {
			var filterCount = 0;
			for (var key in vm.sampleFilters) {
				if (vm.sampleFilters[key] !== null &&
					vm.sampleFilters[key] !== undefined &&
					vm.sampleFilters[key] !== "") {
					filterCount++;
				}
			}
			vm.totalFilters = filterCount;
		}

		function buildGraphQLFilters() {
			var filters = {};
			var sf = vm.sampleFilters;

			if (sf.id) filters.id = parseInt(sf.id);
			if (sf.orderId) filters.orderId = parseInt(sf.orderId);
			if (sf.sampleName) filters.sampleName = sf.sampleName;
			if (sf.lotNumber) filters.lotNumber = sf.lotNumber;
			if (sf.metrcId) filters.metrcId = sf.metrcId;
			if (sf.categoryIdList && sf.categoryIdList.length) filters.categoryIdList = sf.categoryIdList;
			if (sf.category && sf.category.id) filters.categoryIdList = [sf.category.id];
			if (sf.subCategory && sf.subCategory.id) filters.subCategoryId = sf.subCategory.id;
			if (sf.orderType && sf.orderType !== 'ALL') filters.orderType = sf.orderType;
			if (sf.thcLower) filters.thcLower = parseFloat(sf.thcLower);
			if (sf.thcUpper) filters.thcUpper = parseFloat(sf.thcUpper);
			if (sf.cbdLower) filters.cbdLower = parseFloat(sf.cbdLower);
			if (sf.cbdUpper) filters.cbdUpper = parseFloat(sf.cbdUpper);
			if (sf.isPass) filters.isPass = true;
			if (sf.isFail) filters.isFail = true;
			if (sf.isUndetermined) filters.isUndetermined = true;
			if (sf.visibility) filters.visibility = sf.visibility;
			if (sf.isWeedmapsSuccess) filters.isWeedmapsSuccess = true;
			if (sf.isWeedmapsFail) filters.isWeedmapsFail = true;
			if (sf.isWeedmapsNone) filters.isWeedmapsNone = true;
			if (sf.starred || $scope.starred) filters.starred = true;

			if (sf.completeDateLower) {
				filters.completeDateLower = $filter('date')(sf.completeDateLower, 'yyyy-MM-dd');
			}
			if (sf.completeDateUpper) {
				filters.completeDateUpper = $filter('date')(sf.completeDateUpper, 'yyyy-MM-dd');
			}
			if (sf.estimatedDueDateLower) {
				filters.estimatedDueDateLower = $filter('date')(sf.estimatedDueDateLower, 'yyyy-MM-dd');
			}
			if (sf.estimatedDueDateUpper) {
				filters.estimatedDueDateUpper = $filter('date')(sf.estimatedDueDateUpper, 'yyyy-MM-dd');
			}
			if (vm.currentSearch) {
				filters.search = vm.currentSearch;
			}

			return filters;
		}

		function mapGraphQLSample(sample) {
			return {
				id: sample.id,
				name: sample.name,
				hash: sample.hash,
				picture: sample.pictureUrl || "content/images/no_image_available-small.png",
				lot_batch_number: sample.lotBatchNumber,
				lotBatchNumber: sample.lotBatchNumber,
				status: sample.status,
				starred: sample.starred,
				is_public: sample.isPublic,
				isPublic: sample.isPublic,
				canSeeReport: sample.canSeeReport,
				can_see_report: sample.canSeeReport,
				complete: sample.complete,
				rd: sample.rd,
				s_code: sample.sCode,
				sCode: sample.sCode,
				sample_matrix: sample.sampleMatrix,
				sampleMatrix: sample.sampleMatrix,
				weedmaps_state: sample.weedmapsState,
				weedmapsState: sample.weedmapsState,
				order_id: sample.orderId,
				customerOrderId: sample.orderId,
				order: {
					id: sample.orderId,
					date_received: sample.orderDateReceived,
					dateReceived: sample.orderDateReceived,
					date_completed: sample.orderDateCompleted,
					dateCompleted: sample.orderDateCompleted,
					order_type: sample.orderType
				},
				customerOrder: {
					id: sample.orderId,
					dateReceived: sample.orderDateReceived,
					dateCompleted: sample.orderDateCompleted
				},
				productCategory: sample.productCategoryName ? { name: sample.productCategoryName } : null,
				productType: sample.productTypeName ? { name: sample.productTypeName } : null,
				strainName: sample.strainName ? { name: sample.strainName } : null,
				strainType: sample.strainType ? { name: sample.strainType } : null,
				dueDateDisplay: sample.dueDate,
				receivedDate: sample.orderDateReceived,
				dateCompleted: sample.orderDateCompleted,
				testCount: sample.testCount,
				sampleTests: [],
				thcDisplay: null,
				cbdDisplay: null,
				totalCannabinoidsDisplay: null
			};
		}

		function getCompanyPageBatchQuery() {
			return [
				'query GetCompanyPageSamplesBatch($customerHash: String!, $sampleIds: [Int!]!) {',
				'  companyPageSamplesBatch(customerHash: $customerHash, sampleIds: $sampleIds) {',
				'    sampleId',
				'    thc',
				'    cbd',
				'    totalCannabinoids',
				'    tests {',
				'      id',
				'      assayId',
				'      assayTitle',
				'      assayPortalIdentifier',
				'      assayWorksheetId',
				'      state',
				'      statusPf',
				'      canSeeResults',
				'      caution',
				'      estimatedCompleteDate',
				'      worksheetData',
				'    }',
				'  }',
				'}'
			].join('\n');
		}

		function applyCompanyPageBatchPayload(sample, payload) {
			if (!sample || !payload) {
				return sample;
			}

			sample.thcDisplay = payload.thc;
			sample.cbdDisplay = payload.cbd;
			sample.totalCannabinoidsDisplay = payload.totalCannabinoids;
			sample.sampleTests = (payload.tests || []).map(function(test) {
				return {
					id: test.id,
					assay: {
						id: test.assayId,
						title: test.assayTitle,
						portalIdentifier: test.assayPortalIdentifier,
						worksheet_id: test.assayWorksheetId
					},
					state: test.state,
					statusPf: test.statusPf,
					canSeeResults: test.canSeeResults,
					caution: test.caution,
					estimatedCompleteDate: test.estimatedCompleteDate,
					worksheetData: test.worksheetData
				};
			});
			sample._companyPageBatchLoaded = true;
			vm.testResultsCache[sample.id] = sample.sampleTests;
			return sample;
		}

		function ensureCompanyPageSampleBatchData(sample) {
			if (!sample) {
				return $q.reject(new Error('Missing sample'));
			}

			if (sample._companyPageBatchLoaded ||
				(sample.sampleTests && sample.sampleTests.length > 0) ||
				sample.thcDisplay ||
				sample.cbdDisplay ||
				sample.totalCannabinoidsDisplay) {
				sample._companyPageBatchLoaded = true;
				return $q.when(sample);
			}

			if (sample._companyPageBatchPromise) {
				return sample._companyPageBatchPromise;
			}

			var batchPromise = GraphQLService.publicQuery(getCompanyPageBatchQuery(), {
				customerHash: vm.customerHash,
				sampleIds: [sample.id]
			}).then(function(data) {
				var payload = (data.companyPageSamplesBatch || [])[0];
				if (payload) {
					applyCompanyPageBatchPayload(sample, payload);
				} else {
					sample._companyPageBatchLoaded = true;
				}
				return sample;
			}, function(error) {
				return $q.reject(error);
			});

			sample._companyPageBatchPromise = batchPromise;
			batchPromise.finally(function() {
				sample._companyPageBatchPromise = null;
			});
			return batchPromise;
		}

		function loadCompanyPageBatchData() {
			if (!vm.samples || vm.samples.length === 0) return;

			var sampleIds = vm.samples.map(function(sample) { return sample.id; });
			GraphQLService.publicQuery(getCompanyPageBatchQuery(), {
				customerHash: vm.customerHash,
				sampleIds: sampleIds
			}).then(function(data) {
				var payloadBySampleId = {};
				(data.companyPageSamplesBatch || []).forEach(function(payload) {
					payloadBySampleId[payload.sampleId] = payload;
				});

				vm.samples.forEach(function(sample) {
					var payload = payloadBySampleId[sample.id];
					if (!payload) {
						return;
					}

					applyCompanyPageBatchPayload(sample, payload);
				});
			}).catch(function(error) {
				console.error('GraphQL Error loading company page batch data:', error);
			});
		}

		function cancelDeferredCompanyPageBatchLoad() {
			if (!deferredCompanyPageBatchLoad) {
				return;
			}

			if (deferredCompanyPageBatchLoad.type === 'timeout') {
				$timeout.cancel(deferredCompanyPageBatchLoad.handle);
			} else if (deferredCompanyPageBatchLoad.type === 'idle' && window.cancelIdleCallback) {
				window.cancelIdleCallback(deferredCompanyPageBatchLoad.handle);
			}

			deferredCompanyPageBatchLoad = null;
		}

		function scheduleCompanyPageBatchLoad() {
			cancelDeferredCompanyPageBatchLoad();

			if (window.requestIdleCallback) {
				deferredCompanyPageBatchLoad = {
					type: 'idle',
					handle: window.requestIdleCallback(function() {
						deferredCompanyPageBatchLoad = null;
						loadCompanyPageBatchData();
					}, { timeout: 800 })
				};
				return;
			}

			deferredCompanyPageBatchLoad = {
				type: 'timeout',
				handle: $timeout(function() {
					deferredCompanyPageBatchLoad = null;
					loadCompanyPageBatchData();
				}, 250, false)
			};
		}

		function loadAllWithGraphQL() {
			var samplesQuery = [
				'query GetCompanyPageSamples($customerHash: String!, $page: Int!, $size: Int!, $sort: String, $filters: SampleFilters) {',
				'  companyPageSamplesList(customerHash: $customerHash, page: $page, size: $size, sort: $sort, filters: $filters) {',
				'    samples {',
				'      id',
				'      name',
				'      hash',
				'      pictureUrl',
				'      lotBatchNumber',
				'      status',
				'      starred',
				'      isPublic',
				'      canSeeReport',
				'      complete',
				'      rd',
				'      sCode',
				'      sampleMatrix',
				'      weedmapsState',
				'      orderId',
				'      orderDateReceived',
				'      orderDateCompleted',
				'      orderType',
				'      productCategoryName',
				'      productTypeName',
				'      strainName',
				'      strainType',
				'      dueDate',
				'      testCount',
				'    }',
				'    totalCount',
				'  }',
				'}'
			].join('\n');

			return GraphQLService.publicQuery(samplesQuery, {
				customerHash: vm.customerHash,
				page: vm.page || pagingParams.page || 1,
				size: parseInt(vm.itemsPerPage) || 20,
				sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
				filters: buildGraphQLFilters()
			}).then(function(data) {
				vm.samples = (data.companyPageSamplesList.samples || []).map(mapGraphQLSample);
				vm.totalItems = data.companyPageSamplesList.totalCount;
				vm.queryCount = vm.totalItems;
				vm.page = pagingParams.page;
				vm.pagingParams = pagingParams;
				updateFilterCount();
				scheduleCompanyPageBatchLoad();
			});
		}

		function handleCompanyPageGraphQLError(error) {
			console.error('GraphQL Error loading company page samples:', error);
			AlertService.error('Unable to load company page samples right now.');
		}

		function loadAll () {
			loadAllWithGraphQL().catch(handleCompanyPageGraphQLError);
        }

	    function getCustomerData () {
	        CompanyPage.getCustomer({customer_hash: vm.customerHash}, onSuccess, onError); //Does not work for this page.
	        function onSuccess(data, headers) {
	             vm.customerData = data;
	        }
	        function onError(error) {
	        }
	    }

	    getCustomerData();

        /* Hover functions */
        function isOtherAnalysis(test){
        	if (test && test.assay && test.assay.id){
        		if (test.assay.id == 26 || test.assay.id == 15 || test.assay.id == 18 || test.assay.id == 19) {
        			return true;
        		}
        	}
        	return false;
        }
        function hasOtherAnalyses(sample){
        	if (!sample.sampleTests) return false;
        	for (var i=0; i < sample.sampleTests.length; i++){
        		if (!sample.sampleTests[i].assay) continue;
        		if (isOtherAnalysis(sample.sampleTests[i])){
        			return true;
        		}
        	}
        	return false;
        }
		function hasCannabinoids(sample){
			if (!sample || !sample.sampleTests || !vm.cannabioidWorksheets || !vm.cannabioidWorksheets.length) {
				return false;
			}
			for (var i=0; i < sample.sampleTests.length; i++){
				if (isCannabinoidWorksheet(sample.sampleTests[i])){
					return true;
				}
			}
	        	return false;
	        }

		function getTotalThc(sample) {
			if (sample && sample.thcDisplay) {
				return sample.thcDisplay;
			}
			if (!sample || !sample.sampleTests || !vm.cannabioidWorksheets || !vm.cannabioidWorksheets.length) {
				return 'N/A';
			}
        	for (var i = 0; i < sample.sampleTests.length; i++){
        		var test = sample.sampleTests[i];
	        		if (!isCannabinoidWorksheet(test) || !test.worksheetData) {
	        			continue;
	        		}
        		var ws = test.worksheetData;
        		var percentField = ws.total_dry_percent ? ws.total_dry_percent : ws.total_percent;
        		var display = formatPotencyValue(percentField, '%', { noLeadingSpace: true });
        		if (display) {
        			return display;
        		}
        	}
        	return 'N/A';
	        }

	        function getWorksheetPotency(ws, potencyType, isTotal) {
	        	if (!ws) {
	        		return '';
	        	}
	        	var potency = '';

        	if (ws['total_' + potencyType + '_mgpp']) {
        		potency = isTotal ? formatPotencyValue(ws['total_mgpp'], 'mg/pkg') : formatPotencyValue(ws['total_' + potencyType + '_mgpp'], 'mg/pkg');
        	}

        	if (!potency && isSingleUnitPackage(ws)) {
        		potency = isTotal ? formatPotencyValue(ws['total_mgpu'], 'mg/serving') : formatPotencyValue(ws['total_' + potencyType + '_mgpu'], 'mg/serving');
        	}

        	if (!potency && hasMoistureValue(ws)) {
        		potency = isTotal
        			? formatPotencyValue(ws['total_dry_percent'], '%', { noLeadingSpace: true, trailingText: ' (dry)' })
        			: formatPotencyValue(ws['total_' + potencyType + '_dry_percent'], '%', { noLeadingSpace: true, trailingText: ' (dry)' });
        	}

        	if (!potency) {
        		potency = isTotal
        			? formatPotencyValue(ws['total_percent'], '%', { noLeadingSpace: true })
        			: formatPotencyValue(ws['total_' + potencyType + '_percent'], '%', { noLeadingSpace: true });
        	}

        	return potency;
        }

        function formatPotencyValue(field, unit, options) {
        	if (!field) {
        		return '';
        	}
        	var zeroValue = isZeroField(field);
        	var displayValue = getWorksheetDisplayValue(field);
        	if ((displayValue === null || displayValue === undefined || displayValue === '') && !zeroValue) {
        		return '';
        	}

        	var formattedValue = zeroValue ? '0' : displayValue;
        	var result = formattedValue;
        	var opts = options || {};

        	if (unit) {
        		var separator = opts.noLeadingSpace ? '' : ' ';
        		result += separator + unit;
        	}

        	if (opts.trailingText) {
        		result += opts.trailingText;
        	}

        	return result;
        }

        function getWorksheetDisplayValue(field) {
        	if (!field) {
        		return null;
        	}
        	if (typeof field === 'object') {
        		var bestValue = null;
        		var bestDigits = Number.MAX_VALUE;

        		if (hasContent(field.twoDecimalFormattedValue)) {
        			bestValue = field.twoDecimalFormattedValue;
        			bestDigits = countDigits(bestValue);
        		}

        		if (hasContent(field.value)) {
        			var normalizedValue = normalizeNumericValue(field.value);
        			var rawDigits = countDigits(normalizedValue);
        			if (bestValue === null || rawDigits < bestDigits) {
        				bestValue = normalizedValue;
        				bestDigits = rawDigits;
        			}
        		}

        		if (bestValue !== null) {
        			return bestValue;
        		}
        	}
        	return field;
        }

        function getWorksheetRawValue(field) {
        	if (!field) {
        		return null;
        	}
        	if (typeof field === 'object') {
        		if (hasContent(field.value)) {
        			return field.value;
        		}
        		if (hasContent(field.twoDecimalFormattedValue)) {
        			return field.twoDecimalFormattedValue;
        		}
        	}
        	return field;
        }

        function isZeroField(field) {
        	var raw = getWorksheetRawValue(field);
        	if (raw === null || raw === undefined || raw === '') {
        		return false;
        	}
        	if (typeof raw === 'number') {
        		return raw === 0;
        	}
        	var parsed = parseFloat(raw);
        	return !isNaN(parsed) && parsed === 0;
        }

        function hasContent(value) {
        	return value !== undefined && value !== null && value !== '';
        }

        function countDigits(value) {
        	var text = (value + '').trim();
        	if (!text) {
        		return 0;
        	}
        	var digitsOnly = text.replace(/[^0-9]/g, '');
        	return digitsOnly.length ? digitsOnly.length : text.length;
        }

        function normalizeNumericValue(value) {
        	if (value === null || value === undefined || value === '') {
        		return '';
        	}
        	var numberValue = Number(value);
        	if (!isFinite(numberValue)) {
        		return (value + '').trim();
        	}
        	var normalized = numberValue.toString();
        	if (normalized.indexOf('e') !== -1 || normalized.indexOf('E') !== -1) {
        		normalized = numberValue.toFixed(6).replace(/0+$/, '').replace(/\.$/, '');
        	}
        	if (normalized.indexOf('.') !== -1) {
        		normalized = normalized.replace(/\.0+$/, '');
        	}
        	return normalized;
        }

	        function isSingleUnitPackage(ws) {
	        	if (!ws || ws.units_per_package === undefined || ws.units_per_package === null) {
	        		return false;
	        	}
	        	var raw = getWorksheetRawValue(ws.units_per_package);
	        	if (raw === null || raw === undefined || raw === '') {
	        		return true;
	        	}
	        	if (typeof raw === 'number') {
	        		return raw === 1;
	        	}
	        	var parsed = parseFloat(raw);
	        	if (!isNaN(parsed)) {
	        		return parsed === 1;
	        	}
	        	return raw === '1';
	        }

	        function hasMoistureValue(ws) {
	        	if (!ws || !ws.moisture) {
	        		return false;
	        	}
	        	var raw = getWorksheetRawValue(ws.moisture);
	        	if (raw === null || raw === undefined || raw === '') {
	        		return false;
	        	}
	        	if (typeof raw === 'number') {
	        		return raw !== 0;
	        	}
	        	var parsed = parseFloat(raw);
	        	if (isNaN(parsed)) {
	        		return false;
	        	}
	        	return parsed !== 0;
	        }

	        function isCannabinoidWorksheet(test) {
	        	if (!test || !test.assay || !vm.cannabioidWorksheets || !vm.cannabioidWorksheets.length) {
	        		return false;
	        	}
	        	return vm.cannabioidWorksheets.indexOf(test.assay.worksheet_id) !== -1;
	        }

        vm.copyLink = function(id) {
      	  /* Get the text field */
      	  var copyText = document.getElementById(id);
      	  /* Select the text field */
      	  copyText.select();
      	  copyText.setSelectionRange(0, 99999); /*For mobile devices*/
      	  /* Copy the text inside the text field */
      	  document.execCommand("copy");
        }

       loadAll();

       if (vm.sampleFilters.category) {
       	vm.populateTypes();
       }

       vm.startIndex = 0;
       vm.endIndex = 0;

    }

})();
